import React, { useEffect, useMemo, useState } from "react";
import { Copy, ExternalLink, QrCode, Mail, Search } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Card, Empty } from "@/components/admin/ui";
import { EmailDialog, PaperFormsPicker, linkFor, printFlyer } from "@/pages/admin/OrgLinks";

export function DowAppLinks() {
  const [orgs, setOrgs] = useState<any[]>([]);
  const [q, setQ] = useState("");
  const [mailOrg, setMailOrg] = useState<any>(null);
  useEffect(() => { api.get("/dow/organizations").then((r) => setOrgs(r.data)).catch(() => {}); }, []);
  const list = useMemo(() => orgs.filter((o) => `${o.name} ${o.charter || ""}`.toLowerCase().includes(q.toLowerCase())), [orgs, q]);
  const copy = (url: string) => navigator.clipboard.writeText(url).then(() => toast.success("Link copied"));
  return (
    <div className="space-y-6">
      <Card title="Application links" testId="dow-links-card">
        <div className="p-1">
          <div className="relative m-3 max-w-sm"><Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#94A3B8]" />
            <input className="field-input pl-9" placeholder="Search parish, school or charter #" value={q} onChange={(e) => setQ(e.target.value)} data-testid="dow-links-search" />
          </div>
          {!list.length ? <Empty text="No Diocese organizations found." /> : (
            <div className="max-h-[480px] overflow-auto">
              <table className="tbl" data-testid="dow-links-table">
                <thead><tr><th>Organization</th><th>Payment</th><th>Application link</th><th></th></tr></thead>
                <tbody>
                  {list.map((o) => {
                    const url = linkFor(o);
                    return (
                      <tr key={o.id} data-testid={`dow-link-row-${o.id}`}>
                        <td className="font-semibold">{o.name}</td>
                        <td>{o.applicant_pays ? <span className="font-mono font-semibold">${Number(o.applicant_fee || 50).toFixed(2)}</span> : <span className="text-sm text-[#64748B]">Entry code</span>}</td>
                        <td className="min-w-[240px] max-w-[340px]"><span className="break-all font-mono text-xs" data-testid={`dow-link-url-${o.id}`}>{url}</span>
                          {!o.applicant_pays && <p className="text-xs text-[#94A3B8]">Applicants enter their code here</p>}</td>
                        <td className="whitespace-nowrap">
                          <button className="btn-secondary btn-sm" onClick={() => copy(url)} data-testid={`dow-link-copy-${o.id}`}><Copy className="h-4 w-4" /> Copy</button>
                          <a className="btn-secondary btn-sm ml-2" href={url} target="_blank" rel="noreferrer" title="Open link" data-testid={`dow-link-open-${o.id}`}><ExternalLink className="h-4 w-4" /></a>
                          <button className="btn-secondary btn-sm ml-2" onClick={() => printFlyer(o, url)} data-testid={`dow-link-qr-${o.id}`}><QrCode className="h-4 w-4" /> QR flyer</button>
                          <button className="btn-secondary btn-sm ml-2" onClick={() => setMailOrg(o)} data-testid={`dow-link-email-${o.id}`}><Mail className="h-4 w-4" /> Email</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </Card>
      <EmailDialog open={!!mailOrg} onClose={() => setMailOrg(null)} testId="dow-link-email" title={`Email application link: ${mailOrg?.name || ""}`}
        withMessage send={(to, message) => api.post(`/dow/organizations/${mailOrg.id}/email-link`, { to, message })} />
      <Card title="Paper forms" testId="dow-paper-forms-card"><div className="p-4" data-testid="dow-paper-forms"><PaperFormsPicker orgs={orgs.filter((o) => !o.parent_org_id)} base="/dow" /></div></Card>
    </div>
  );
}
